import { render } from "./NewVersionBanner.vue?vue&type=template&id=4496bc18&ts=true"
import script from "./NewVersionBanner.vue?vue&type=script&lang=ts"
export * from "./NewVersionBanner.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBanner from 'quasar/src/components/banner/QBanner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBanner,QBtn});
